<template>
    <div class="full-height">
        <!--<transition name="fade">-->
        <div id="bookingForm" class="cbs-booking-form booking-container thin-scroll">
            <form action="#" novalidate vv-on:submit="bookingFormSubmit" class="booking-form mb-0">
                <div class="booking-type-tabs" v-if="showBookingTypeSwitcher">
                    <ul class="nav nav-tabs nav-fill">
                        <li class="nav-item">
                            <a class="nav-link" v-bind:class="{ active: !isHourlyBooking }" v-on:click="bookingTypeChanged(1)">
                                <span>TRANSFER</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" v-bind:class="{ active: isHourlyBooking }" v-on:click="bookingTypeChanged(2)">HOURLY</a>
                        </li>
                    </ul>
                </div>

                <div class="form-group mt-3">
                    <div class="input-group mb-2">
                        <vue-google-autocomplete id="bookingPickupLocation" name="pickupLocation" 
                                                 classname="form-control" :placeholder="$t('forms.booking.selectYourHomeAddress')"
                                                 :country="getAutocompleteCountry" v-model="pickupLocation">
                        </vue-google-autocomplete>
                    </div>
                    <div v-if="showErrors">
                        <div class="error-message" v-if="!this.pickupLocation.location">Please select pickup location.</div>
                    </div>
                </div>
         
                <div class="form-group" v-show="!isHourlyBooking">
                    <div class="input-group mb-2">
                        <vue-google-autocomplete id="bookingDrpoffLocation" name="bookingDrpoffLocation"
                                                 classname="form-control" placeholder="Drop-off address or airport"
                                                 :country="getAutocompleteCountry" v-model="dropoffLocation">
                        </vue-google-autocomplete>
                    </div>
                    <div v-if="showErrors">
                        <div class="error-message" v-if="!this.isHourlyBooking && !this.dropoffLocation.location">Please select drop-off location.</div>
                    </div>
                </div>

                <div class="form-group" v-show="isHourlyBooking && !this.useEndTimeInsteadOfBookingDuration">
                    <div class="input-group full-row mb-2">
                        <select class="form-control" v-bind:class="{ notSelected: bookingDuration == 0 }" v-model="bookingDuration">
                            <option :key="option.value" v-for="option in bookingAllowedDurations" :label="$t(option.text)" :value="option.value">
                                {{ option.text }}
                            </option>
                        </select>
                    </div>
                    <div v-if="showErrors">
                        <div class="error-message" v-if="this.isHourlyBooking && !this.bookingDuration">Please select number of hours.</div>
                    </div>
                </div>

                <div class="row mt-3" v-show="!this.isHourlyBooking">
                    <div class="col-6">
                        <vue-date-picker v-model="pickupDate" id="bookingPickupDate" name="bookingPickupDate"
                                         type="text" class="form-control d-inline-block"
                                         style="border-radius: 0;" :placeholder="$t('forms.booking.date')">
                        </vue-date-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="!this.pickupDate">Pickup date is required.</div>
                        </div>
                    </div>
                    <div class="col-6">
                        <vue-time-picker v-model="pickupTime" id="bookingPickupTime" type="text" class="form-control"
                         :placeholder="$t('forms.booking.time')">
                        </vue-time-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="!this.pickupTime">Pickup time is required.</div>
                        </div>
                    </div>
                </div>
                
                <!-- return booking -->
                <div class="row mt-3" v-show="!this.isHourlyBooking && showReturnOption">
                    <div class="col text-left">
                        <label class="check">
                            <input type="checkbox" name="needReturn" v-model="needReturn" />
                            <span class="checkmark"></span> {{$t('forms.booking.needReturnLabel')}}
                        </label>
                    </div>                    
                </div>
                <div class="row" v-show="!this.isHourlyBooking && needReturn">
                    <div class="col-6">
                        <vue-date-picker v-model="returnPickupDate" id="bookingReturnPickupDate" name="bookingReturnPickupDate"
                                        type="text" class="form-control d-inline-block"
                                        style="border-radius: 0;" :placeholder="$t('forms.booking.date')">
                        </vue-date-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="needReturn && !this.returnPickupDate">Return pickup date is required.</div>
                        </div>
                    </div>
                    <div class="col-6">
                        <vue-time-picker v-model="returnPickupTime" id="bookingReturnPickupTime" type="text" class="form-control"
                            :placeholder="$t('forms.booking.time')">
                        </vue-time-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="needReturn && !this.returnPickupTime">Return pickup time is required.</div>
                        </div>
                    </div>
                </div>
                <!-- END return booking -->

                <div class="row mt-3" v-show="this.isHourlyBooking">
                    <div class="col-2"><span class="d-inline-block align-middle">{{$t('forms.booking.startLabel')}}:</span></div>
                    <div class="col-5">
                        <vue-date-picker v-model="pickupDate" id="bookingPickupDateHourly" name="bookingPickupDate"
                                         type="text" class="form-control d-inline-block"
                                         style="border-radius: 0;" :placeholder="$t('forms.booking.date')">
                        </vue-date-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="!this.pickupDate">Pickup date is required.</div>
                        </div>
                    </div>
                    <div class="col-5">
                        <vue-time-picker v-model="pickupTime" id="bookingPickupTimeHourly" type="text" class="form-control"
                         :placeholder="$t('forms.booking.time')">
                        </vue-time-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="!this.pickupTime">Pickup time is required.</div>
                        </div>
                    </div>
                </div>

                <!-- Select booking duration mode -->
                <div class="row mt-3" v-if="this.isHourlyBooking && this.useEndTimeInsteadOfBookingDuration">
                    <div class="col-2"><span class="d-inline-block align-middle">{{$t('forms.booking.endLabel')}}:</span></div>
                    <div class="col-5">
                        <vue-date-picker v-model="dropoffDate" id="bookingEndDate" name="bookingEndDate"
                                         type="text" class="form-control d-inline-block"
                                         style="border-radius: 0;" :placeholder="$t('forms.booking.date')">
                        </vue-date-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="this.useEndTimeInsteadOfBookingDuration && !this.dropoffDate">Booking end date is required.</div>
                        </div>
                    </div>
                    <div class="col-5">
                        <vue-time-picker v-model="dropoffTime" id="bookingPickupTime" type="text" class="form-control" :placeholder="$t('forms.booking.time')">
                        </vue-time-picker>
                        <div v-if="showErrors">
                            <div class="error-message" v-if="this.useEndTimeInsteadOfBookingDuration && !this.dropoffTime">Pickup end time is required.</div>
                        </div>
                    </div>
                </div>

                <div class="row mb-0" v-if="this.errors.length > 0">
                    <div class="col">
                        <ul class="list-unstyled error">
                            <li v-for="item in this.errors" :key="item" v-html="item"></li>
                        </ul>
                    </div>
                </div>

                <div class="row mt-2" v-if="this.isNotCoveredPickup">
                    <div class="col text-center">
                        <span v-show="this.showCallOnNotCoveredPickup">
                            <a class="btn btn-sm btn-info" target="_top" :href="contactPhoneNumberHref">Call {{contactPhoneNumber}}</a> OR
                        </span>
                        <button class="btn btn-sm btn-success" type="button" href="#"
                                @click="$store.commit('setShowContactForm', true)">Ask For Quote</button>
                    </div>
                </div>

                <div class="row mt-3 mb-3">
                    <div class="col-12 text-center">
                        <button type="button" class="btn btn-primary" v-on:click="goToNextStep()">
                            <!-- <span v-show="loadingPrice"><i class="fa fa-spinner fa-spin"></i></span> -->
                            <div class="spinner-border spinner-border-sm" v-show="loadingPrice" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                            {{$t('forms.booking.checkPrice')}}
                        </button>
                    </div>
                </div>
            </form>
        </div>
        <!--</transition>-->
        <!--<div class="validators">
            <pre>{{this.pickupTime}}</pre>
        </div>-->
    </div>
</template>

<script>
    import moment from 'moment';

    import VueGoogleAutocomplete from "../vue-google-autocomplete/vue-google-autocomplete.vue";
    import VueDatePicker from "../vue-pickadate/pickadate.vue";
    import VueTimePicker from "../vue-pickadate/pickatime.vue";
    import Vuelidate from 'vuelidate';
    import { required } from 'vuelidate/lib/validators';
    import Vue from "vue";

    Vue.use(Vuelidate);

    export default {        
        name: "BookingForm",
        components: {
            VueGoogleAutocomplete,
            VueDatePicker,
            VueTimePicker,
        },
        data: function () {
            return {
                showErrors: false,
                errors: [],
                loadingPrice: false,
                //needReturn: false
                //useBookingDuration: true,
                //pickupEndDate: null,
                //pickupEndTime: null,
                //message: BookingInfoStore.state.message
            };
        },
        mounted: function(){
            //this.$store.commit('booking/setBookingType', this.$store.state.booking.configuration.defaultBookingType);
        },
        validations: {
            pickupLocation: { required },
        },
        computed: {
            useEndTimeInsteadOfBookingDuration: function(){
                return this.$store.state.booking.configuration.useEndTimeInsteadOfBookingDuration;
            },
            showBookingTypeSwitcher: function () {
                return this.$store.getters['booking/showBookingTypeSwitcher'];
            },
            showReturnOption:  function () {
                return this.$store.getters['booking/showReturnOption'];
            },
            getAutocompleteCountry: function () {
                return this.$store.state.booking.configuration.country;
            },
            isHourlyBooking: function () {
                return this.$store.state.booking.bookingInfo.general.bookingType === 2;
            },
            bookingAllowedDurations: function () {
                return this.$store.state.booking.configuration.bookingDurations;
            },
            isNotCoveredPickup: function () {
                return this.$store.getters.isNotCoveredLocation;
            },
            showCallOnNotCoveredPickup: function () {
                return this.$store.state.booking.configuration.showCallOnNotCoveredPickup;
            },
            contactPhoneNumber: function () {
                return this.$store.state.booking.configuration.contactPhone;
            },
            contactPhoneNumberHref: function () {
                if (this.contactPhoneNumber.startsWith('+')) {
                    return 'tel: ' + this.contactPhoneNumber;
                } else {
                    return 'tel: +' + this.contactPhoneNumber;
                }
            },
            pickupLocation:  {
                get: function () {
                    return this.$store.state.booking.bookingInfo.general.pickupAddress;
                },
                set: function (newValue) {
                    this.$store.commit('booking/setPickupLocation', newValue);
                }
            },
            dropoffLocation: {
                get: function () { return this.$store.state.booking.bookingInfo.general.dropOffAddress; },
                set: function (value) { this.$store.commit('booking/setDropoffLocation', value); }
            },
            pickupDate: {
                get: function() {
                    return this.$store.state.booking.bookingInfo.general.pickupDate;
                },
                set: function (value) {
                    this.$store.commit('booking/setPickupDate', value);
                }
            },
            pickupTime: {
                get: function () {
                    return this.$store.state.booking.bookingInfo.general.pickupTime;
                },
                set: function (value) {
                    this.$store.commit('booking/setPickupTime', value);
                }
            },
            dropoffDate: {
                get: function() {
                    return this.$store.state.booking.bookingInfo.general.dropoffDate;
                },
                set: function (value) {
                    this.$store.commit('booking/setDropoffDate', value);
                }
            },
            dropoffTime: {
                get: function () {
                    return this.$store.state.booking.bookingInfo.general.dropoffTime;
                },
                set: function (value) {
                    this.$store.commit('booking/setDropoffTime', value);
                }
            },
            needReturn: {
                get: function() {
                    return this.$store.state.booking.bookingInfo.general.needReturn;
                },
                set: function (value) {
                    this.$store.commit('booking/setNeedReturn', value);
                }
            },
            returnPickupDate: {
                get: function() {
                    return this.$store.state.booking.bookingInfo.general.returnPickupDate;
                },
                set: function (value) {
                    this.$store.commit('booking/setReturnPickupDate', value);
                }
            },
            returnPickupTime: {
                get: function () {
                    return this.$store.state.booking.bookingInfo.general.returnPickupTime;
                },
                set: function (value) {
                    this.$store.commit('booking/setReturnPickupTime', value);
                }
            },
            bookingDuration: {
                get: function () {
                    return this.$store.state.booking.bookingInfo.general.durationInHours;
                },
                set: function (newValue) {
                    this.$store.commit('booking/setDurationInHours', newValue);
                }
            }, 
            isPriceLoading: function () { return this.$store.state.booking.bookingInfo.general.isPriceLoading; },
            //errors: function () { return this.$store.state.booking.bookingInfo.general.serverPriceErrors; }
        },
        methods: {
            isBookingFormValid: function () {
                var isValid = true;
                
                //in case of duration computation -> end date & time should be selected
                if((this.isHourlyBooking && this.useEndTimeInsteadOfBookingDuration) && (!this.dropoffDate || !this.dropoffTime)) {
                    isValid = false;
                }

                //every booking should have pickup location, date & time
                if (!this.pickupLocation.location || !this.pickupDate || !this.pickupTime) isValid = false;

                //check to have duration for hourly bookings
                if(this.isHourlyBooking) this.fillBookingDuration();


                if (this.isHourlyBooking && !this.bookingDuration) isValid = false;
                if (!this.isHourlyBooking && !this.dropoffLocation.location) isValid = false;
                if (!this.isHourlyBooking && this.needReturn){
                    if(!this.returnPickupDate || !this.returnPickupTime) isValid = false;
                }

                return isValid;
            },
            fillBookingDuration: function(){
                this.errors.length = 0;
                this.bookingDuration = null;
                let startBooking  = moment(this.pickupDate + " " + this.pickupTime, "DD-MM-YYYY HH:mm");
                let endBooking =  moment(this.dropoffDate + " " + this.dropoffTime, "DD-MM-YYYY HH:mm");
                let duration = moment.duration(endBooking.diff(startBooking));
                if(duration.as('hours') > 0){
                    //TODO: compute max of 12h each day (total hours /24 and at each division we add at most 12)
                    this.bookingDuration = duration.as('hours');
                    if(this.bookingDuration > 12){ 
                        let numberOfDays = Math.floor(this.bookingDuration / 24);
                        let remainder = this.bookingDuration - numberOfDays * 24;
                        this.bookingDuration = (numberOfDays * 12) + remainder;
                        console.log("this.bookingDuration ", this.bookingDuration);
                    }
                }
                else { 
                    this.errors.push("End date is before start date. Please try again.")
                }
            },
            goToNextStep: function () {
                var isValid = this.isBookingFormValid();
                if (!isValid) {
                    this.showErrors = true;
                    return;
                }

                this.loadingPrice = true;
                this.$store.dispatch('booking/getBookingPrice')
                .then((result)=>{
                    this.loadingPrice = false;
                    console.log('then reached');
                    if(result.length > 0){
                        this.errors = [];
                         this.showErrors = false;
                        this.$store.commit('booking/setCurrentStep', 2);
                    }
                })
                .catch((err)=>{
                    this.loadingPrice = false;
                    this.errors = err;
                    console.log('catch reached', err);
                });
            },
            bookingTypeChanged: function (data) {
                this.$store.commit('booking/setBookingType', data);
            },
            //bookingDurationChanged: function (ev, data) {
            //    this.$store.commit('setDurationInHours', data);
            //}
        }
    };
</script>

<style>
    .cbs-booking-form .form-control {
        max-width: 100%;
    }

    .cbs-booking-form .list-unstyled.error {
        color: #e25950;
        text-align: center;
        margin-bottom: 20px;
        list-style: none;
    }

    .cbs-booking-form .picker__list {
        list-style: none;
        padding: 0;
    }
</style>
